<template>
  <div>
    <img :src="require('@/assets/bg.png')" class="main">
   <div class="container-fluid row pt-3">
    <nav class="container mx-auto navbar navbar-expand-lg navbar-dark nav-dark pt-5">
        <a href="/" class="navbar-brand">
          <img src="@/assets/logo.png"> 
         <!-- <h6 class="text-light">TESTNET</h6> -->
         
        </a>
    </nav>
  </div>

  <div id="loading" v-if="show.showLoading">
    <div class="content">

      <v-icon name="spinner" pulse scale="3" />

    </div>
  </div>
       
    <div class="container-fluid d-flex justify-content-center">
      <div class="col col-md-6 col-sm-6 pt-3">
              <div class="input-group mb-2">
                <b-input-group-prepend is-text>
                  <b-icon icon="search"></b-icon>
                </b-input-group-prepend>
                <input v-model="init.search" v-on:keyup.enter="search" type="text" class="form-control" placeholder="Enter your valid Transaction hash or valid Wallet Address">
              </div>
      </div>
    </div>

   <!--widget-->
   <Particles
   id="tsparticles"
   :particlesInit="particlesInit"
   :particlesLoaded="particlesLoaded"
   :options="{
       background: {
           color: {
               
           }
       },
       fpsLimit: 120,
       interactivity: {
           events: {
               onClick: {
                   enable: true,
                   mode: 'push'
               },
               onHover: {
                   enable: true,
                   mode: 'repulse'
               },
               resize: true
           },
           modes: {
               bubble: {
                   distance: 400,
                   duration: 1,
                   opacity: 0.8,
                   size: 40
               },
               push: {
                   quantity: 4
               },
               repulse: {
                   distance: 200,
                   duration: 1
               }
           }
       },
       particles: {
           color: {
               value: '#ffffff'
           },
           links: {
               color: '#ffffff',
               distance: 150,
               enable: true,
               opacity: 0.5,
               width: 1
           },
           collisions: {
               enable: true
           },
           move: {
               direction: 'none',
               enable: true,
               outMode: 'bounce',
               random: false,
               speed: 1,
               straight: false
           },
           number: {
               density: {
                   enable: true,
                   area: 800
               },
               value: 80
           },
           opacity: {
               value: 0.5
           },
           shape: {
               type: 'circle'
           },
           size: {
               random: true,
               value: 5
           }
       },
       detectRetina: true
   }"
/>
         
<!--//-->

    <div class="bg2 no-gutter container">
        <div class="table-responsive row main-content container" >

          <table class="text">
            <tr>
                <td>Hash</td>
                <td>{{this.$route.params.txnHash}}</td>
            </tr>
            <!-- <tr>
                <td>Timestamp</td>
                <td>{{formatDate(timeStamp)}}</td>
            </tr> -->
           
            <tr>
                <td>Address</td>
                <td>{{miner}}</td>
            </tr>
            
            <tr>
                <td>Amount</td>
                <td>{{formatAmount(reward) }}</td>
            </tr>
            <tr>
                <td>Status</td>
                <td>{{status}}</td>
            </tr>
            <tr>
                <td>Confirmations</td>
                <td>{{confirmations}}</td>
            </tr>
            
            </table>
        </div>


      </div>

      <div class="pt-5 row main-content">
        <h4 class="text-white">Block Transactions</h4>
          <div class="table-responsive container-fluid row">
           <table id="blocks">
               <thead>
                 
                      <th>Hash</th>
                      <th>Timestamp</th> 
                      <th>Amount</th>
                      <th>Symbol</th>
                      <th>Input</th>
                      <th>Output</th>
                      
                </thead>

                <tbody>
                  <tr>
                   <td id="hash">{{ init.txnDetails.hash }}</td>
                   <td>{{ formatDate(init.txnDetails.input.timeStamp) }}</td> 
                   <td>{{ formatAmount(init.txnDetails.amount) }}</td>
                   <td>{{ init.txnDetails.symbol }}</td>
                   <td>{{ init.txnDetails.input.address != null ? init.txnDetails.input.address : "BLX Genesis Asset"}}
                  <td>{{ init.txnDetails.recipient }}</td>

                    
                   </tr>
                </tbody>
            </table>
        </div>

      </div>
      


  </div>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'


export default {
  name: 'Transaction',
  components: {
    
  },
  data() {
    return{
     txnHash: '',
     height: '',
     miner: '',
     timeStamp: '',
     diff:'',
     reward:'',
     NewlyGeneratedBlx: false,
     confirmations:'',
     status: '',
     
    }
  },
   computed: {
     init() {
            return this.$store.state.init;
        },

        errors() {
            return this.$store.state.errors;
        },

        show() {
            return this.$store.state.show;
        },

        action() {
            return this.$store.state.action;
        },

        list() {
            return this.$store.state.list;
        },
  },
 methods: {
   formatAmount:  function (num) {

      if(isNaN(num)) {
        num = 0;
      }
      return parseFloat(num).toFixed(8)
    },
    search: function(){
            if(this.init.search == "BIXIE" || this.init.search == "bixie") {
              this.$router.push('/bixie/')
            }
            if(this.init.search == "GWX" || this.init.search == "gwx") {
              this.$router.push('/gwx/')
            }
            if(this.init.search == "BLOXDAO" || this.init.search == "bloxdao") {
              this.$router.push('/blox/')
            }
            if(this.init.search == "BLX" || this.init.search == "blx") {
              this.$router.push('/blx/')
            }
    
            if(this.init.search.length == 32 || this.init.search.length == 33 || this.init.search.length == 42 || this.init.search.length == 34 || this.init.search.length == 35) {
              this.$router.push('/search-network/')
              localStorage.setItem("walletAddress", this.init.search);
            } else if(this.init.search.length == 64){
               this.$router.push('/transaction/' + this.init.search)
              if(this.$router.currentRoute.name == 'Transaction') {
                    window.location.reload();
                  }
            } else {
              this.$router.push('/notfound/' + this.init.search);
              if(this.$router.currentRoute.name == 'NotFound') {
                  window.location.reload();
              }

            }
          },
   formatDate: function(date) {
           // return date;
        return moment(date).format('MM/DD/YYYY hh:mm:ss A');
    },
   initTransaction: function(txnHash){
      this.getTxnDetails(txnHash); 
  },
   getTxnDetails: function(txnHash){
     this.show.showLoading = true;
      this.axios.get('/blx-api/txn/' + txnHash)
            .then((response) => {
             // console.log(response.data.symbol)
                this.init.txnDetails = response.data;
                this.miner = response.data.recipient
                this.reward = response.data.amount
                this.confirmations = response.data.confirmations
                this.init.txnDetails.symbol = response.data.symbol
                this.show.showLoading = false;
                
                  if(this.confirmations >= 1) {
                    this.status = "CONFIRMED"
                  } else {
                    this.status = "UNCONFIRMED"
                  };

                  if(this.init.txnDetails.symbol == 'BLOXDAO' || this.init.txnDetails.symbol == 'bloxdao'){
                    this.init.txnDetails.symbol = 'BLOX'
                  }

                  if(this.init.txnDetails.symbol == undefined){
                     this.$router.push('/notfound/' + txnHash);
                  }
                  
            })
    },

 },
 mounted: function(){
        this.initTransaction(this.$route.params.txnHash);
  },
 
  

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main{
    background-image: url('../assets/bg.png');
    background-repeat: no-repeat;
    height: 100vh;
    width: 100%;
    background-position: center;
    background-size: cover;
}
.navbar-brand img{
  width: 10rem;
  margin: auto 100px;
}
.form-control{
 font-size: 10px;
}
.text{
  text-align: left !important;
}
table {
    border-collapse: collapse;     width: 100%;     margin: 0 10px;     background: #414141 !important;     color: white;     text-align: center !important;     font-size: 80%;     border-radius: 10px !important;     padding: 0.5em 2em;     overflow-y: scroll;     max-height: 700px; z-index: 9999 !important;;
}
th, td {
  padding: 0.5em;
}
tr{
  border-top: 1px solid grey;
  width: 100%;
  padding: 0.5em 2em;
}
#blocks thead{
  background-color: #808080;
  width: 100%;
  color: white;
  font-size: 0.875rem;
  letter-spacing: 2%;
  border-radius: 10px !important;
}
table a{
  color: #c68b17;
  text-decoration: none;
}
.container{
  z-index: 9999 !important;
}
.container-fluid{
  z-index: 9999 !important;

}

</style>
